import { DASH_META_ROOT } from '@revelio/auth';

import { getAiSearchCsrfToken } from '../filters/ai-search/ai-search-api-request';

export const formatDescriptionRequest = async ({
  text,
  signal,
}: {
  text: string;
  signal?: AbortSignal;
}): Promise<{ formattedText: string }> => {
  const csrfToken = await getAiSearchCsrfToken();
  const response = await fetch(
    `${DASH_META_ROOT}/api/ai-search/format-description`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-surf-token-dash-meta-ai-search': csrfToken,
      },
      body: JSON.stringify({
        text,
      }),
      credentials: 'include',
      signal,
    }
  );

  if (!response.ok) {
    const message = await response.text();
    const error: Error & { status?: number } = new Error(
      message || 'Unknown error'
    );
    error.status = response.status;
    throw error;
  }

  const data = await response.json();
  return data;
};
